import { Directive, Input, TemplateRef, ViewContainerRef, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';

@Directive({
    selector: '[hasPermission]',
    standalone: true,
})
export class HasPermissionDirective implements OnInit {
    private area: string = '';
    private permission: string = '';

    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        private authService: AuthService
    ) {}

    @Input()
    set hasPermission(value: [string, string]) {
        [this.area, this.permission] = value;
    }

    ngOnInit(): void {
        const hasAccess = this.authService.hasPermission(this.area, this.permission);

        this.viewContainer.clear();

        if (hasAccess) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        }
    }
}
